/**
 * テストコンテンツ名一覧取得API
 */
import { Component, Vue } from 'vue-property-decorator'
import {
  ApiResponseStudyContent,
  ApiResponseExampleStudyContentInfo,
  ApiResponseStudyContentYear,
  ApiResponseStudyContentStudentList,
} from '@/models/apiResponses/studyContents'
import { ApiResponseStudentStudyContent } from '@/models/apiResponses/studentStudyContents'
import { StudySearchParamsType } from '@/models/studyListModel'
import { StudentSelectSearchParamsType } from '@/models/studentListModel'
import { StudyResultSummarySearchParamsType } from '@/models/studyResultListModel'
import { UserRoles } from '@/const/UserRoles'
import { StudyContentSetting } from '@/const/ApiSettings'

@Component
export default class StudyContentsApi extends Vue {
  /**
   * サンプルテストコンテンツ情報取得
   * @returns サンプルテストコンテンツ情報
   */
  protected async getExampleStudyContentInfo(): Promise<ApiResponseExampleStudyContentInfo> {
    const { data }: { data: ApiResponseExampleStudyContentInfo } = await Vue.prototype.$http.httpWithToken.get(
      '/v2/study_contents/example_content_info'
    )

    return data
  }

  /**
   * 管理画面で使用するテストコンテンツ一覧を検索する
   * @param params 検索パラメーター群
   * @param role ユーザー権限
   * @returns テストコンテンツ一覧
   */
  protected async searchStudyContents(
    params: StudySearchParamsType,
    role: UserRoles
  ): Promise<ApiResponseStudyContent[]> {
    const { data }: { data: ApiResponseStudyContent[] } = await Vue.prototype.$http.httpWithToken
      .get(`/v2/${role}/study_contents/search`, {
        params: Object.assign(params, {
          functionType: StudyContentSetting.DEFAULT_FUNCTION_TYPE,
          studyMode: StudyContentSetting.DEFAULT_STUDY_MODE,
        }),
      })
      .catch(() => ({ data: [] }))

    return data
  }

  /**
   * テストコンテンツの実施年度一覧取得
   * @returns 実施年度一覧
   */
  protected async getYears(): Promise<ApiResponseStudyContentYear[]> {
    const { data }: { data: ApiResponseStudyContentYear[] } = await Vue.prototype.$http.httpWithToken.get(
      '/v2/study_contents/years_by_study_mode',
      {
        params: {
          functionType: StudyContentSetting.DEFAULT_FUNCTION_TYPE,
          studyMode: StudyContentSetting.DEFAULT_STUDY_MODE,
        },
      }
    )

    return data
  }

  /**
   * テスト受験済み生徒検索
   * @param params 検索パラメーター群
   * @param role ユーザー権限
   * @returns テスト受験済み生徒一覧
   */
  protected async searchStudentSubjectHistories(
    params: StudentSelectSearchParamsType,
    role: UserRoles
  ): Promise<ApiResponseStudyContentStudentList> {
    const { data }: { data: ApiResponseStudyContentStudentList } = await Vue.prototype.$http.httpWithToken
      .get(`/v2/${role}/study_contents/student_subject_histories`, {
        params: params,
      })
      .catch(() => ({ data: { responses: [], pagination: null } }))

    return data
  }

  /**
   * 生徒毎のテスト結果一覧検索
   * @param params 検索パラメーター群
   * @param role ユーザー権限
   * @returns テスト結果一覧
   */
  protected async getStudyResultContents(
    params: StudyResultSummarySearchParamsType,
    role: UserRoles
  ): Promise<ApiResponseStudentStudyContent[]> {
    const { data }: { data: ApiResponseStudentStudyContent[] } = await Vue.prototype.$http.httpWithToken
      .get(`/v2/${role}/study_contents/search_with_result_drill`, {
        params: params,
      })
      .catch(() => ({ data: [] }))

    return data
  }
}
